export default {
    namespaced: true,
    state: () => ({
        quantity: [],
        supported: {},
    }),
    mutations:
    {
        SET_QUANTITY(state, val) {
            state.quantity = val
        },
        SET_SUPPORTED(state, val)
        {
            state.supported = {...state.supported, ...val}
        }
    }
}